














































































































































































































































































import Vue from "vue";
import { Computed, Data, Method, Props } from "./types";
import smartphoneIcon from "../../assets/ApplicationPlan/smartphone.svg";
import allDeviceIcon from "../../assets/ApplicationPlan/premium.svg";
import TextConverter from "@/lib/textConverter";
import Locale from "@/lib/locale";
import { mapActions } from "vuex";
import { props } from "@/components/ChangePlansSb/props";

export default Vue.extend<Data, Method, Computed, Props>({
  name: "vc-change-plans-sb",
  components: {
    smartphoneIcon: smartphoneIcon,
    allDeviceIcon: allDeviceIcon
  },
  props,
  data: function() {
    return {
      deviceType: this.defaultData.deviceType,
      gradeType: this.defaultData.gradeType,
      termType: this.defaultData.termType,
      currencyCode: this.defaultData.currencyCode,
      monthlyPrice: this.priceMap[
        this.resultPlansMap[this.defaultData.deviceType][
          this.defaultData.gradeType
        ]["month"]
      ][this.defaultData.currencyCode],
      yearlyPrice: this.priceMap[
        this.resultPlansMap[this.defaultData.deviceType][
          this.defaultData.gradeType
        ]["year"]
      ][this.defaultData.currencyCode],
      changePlansData: {
        basetime: 0,
        currencyCode: "",
        settlementScheduledPrice: 0,
        settlementScheduledTerm: "",
        settlementScheduledAt: 0,
        upcomingTotal: 0,
        currentPlanName: "",
        afterPlanName: "",
        freePeriodAt: 0,
        isChangeSettlementScheduledAt: false,
        isInitialMonthInclusiveInvoice: false,
        newPlanCode: ""
      },
      isGetChangePlans: false,
      locale: Locale.getLocale()
    };
  },
  mounted() {
    this.changePrice();
  },
  methods: {
    ...mapActions("changePlansSb", ["getChangeDetail"]),
    submitPlan() {
      const formElement = this.$refs.changeForm as HTMLFormElement;
      const inputPlan = document.createElement("input");
      inputPlan.setAttribute("type", "hidden");
      inputPlan.setAttribute("name", "basetime");
      inputPlan.setAttribute("value", String(this.changePlansData.basetime));
      formElement.appendChild(inputPlan);

      if (this.changePlansData.upcomingTotal) {
        const instantPayment = this.getInstantPayment();
        const inputPlan = document.createElement("input");
        inputPlan.setAttribute("type", "hidden");
        inputPlan.setAttribute("name", "instantPayment");
        inputPlan.setAttribute("value", String(instantPayment));
        formElement.appendChild(inputPlan);
      }

      formElement.submit();
    },
    changePrice() {
      this.monthlyPrice = this.priceMap[
        this.resultPlansMap[this.deviceType][this.gradeType]["month"]
      ][this.currencyCode];
      this.yearlyPrice = this.priceMap[
        this.resultPlansMap[this.deviceType][this.gradeType]["year"]
      ][this.currencyCode];

      // 現状の契約内容と選択項目が同じであれば、契約変更内容の案内は表示しない
      if (!this.isSelectedDifferentFromCurrentContract()) {
        this.isGetChangePlans = false;
        return;
      }

      const requestParams = {
        deviceType: this.deviceType,
        gradeType: this.gradeType,
        termType: this.termType,
        contractNumber: this.contractNumber
      };

      this.getChangeDetail(requestParams).then((res: any) => {
        this.changePlansData = res.changePlansData;
        this.isGetChangePlans = true;
      });
    },
    replaceBr(text: string) {
      return TextConverter.replaceBr(text);
    },
    getNextButtonColorClass(isEnable: boolean) {
      if (this.isPaypalContract) {
        return "componentCardInfoButton--disabled";
      }

      return isEnable
        ? "componentCardInfoButton"
        : "componentCardInfoButton--disabled";
    },
    isSelectedDifferentFromCurrentContract(): boolean {
      return (
        this.currentContractData.deviceType !== this.deviceType ||
        this.currentContractData.gradeType !== this.gradeType ||
        this.currentContractData.termType !== this.termType
      );
    },
    isSelectedDifferentDeviceType(deviceName: string): boolean {
      return (
        this.currentContractData.deviceType === deviceName &&
        this.currentContractData.deviceType !== this.deviceType
      );
    },
    isSelectedDifferentGradeType(gradeName: string): boolean {
      return (
        this.currentContractData.gradeType === gradeName &&
        this.currentContractData.gradeType !== this.gradeType
      );
    },
    isSelectedDifferentTermType(termName: string): boolean {
      return (
        this.currentContractData.termType === termName &&
        this.currentContractData.termType !== this.termType
      );
    },
    getInstantPayment(): number {
      if (!this.changePlansData.upcomingTotal) {
        return 0;
      }

      if (this.changePlansData.isInitialMonthInclusiveInvoice) {
        return (
          this.changePlansData.upcomingTotal +
          this.changePlansData.settlementScheduledPrice
        );
      }

      return this.changePlansData.upcomingTotal;
    }
  },
  computed: {
    isSelectedPlan(): boolean {
      return (
        this.currentContractData.currentPlanCode !==
        this.resultPlansMap[this.deviceType][this.gradeType][this.termType]
      );
    },
    isChangeDevice(): boolean {
      return this.currentContractData.deviceType !== this.deviceType;
    },
    isExToPro(): boolean {
      return (
        this.currentContractData.gradeType === "ex" && this.gradeType === "pro"
      );
    },
    isProToEx(): boolean {
      return (
        this.currentContractData.gradeType === "pro" && this.gradeType === "ex"
      );
    },
    isBillingKonbiniPayment(): boolean {
      const smartPhonePlan = ["CSP_PRO_1s_1mon", "CSP_EX_1s_1mon"];
      return (
        !smartPhonePlan.includes(this.currentContractData.currentPlanCode) &&
        smartPhonePlan.includes(this.changePlansData.newPlanCode) &&
        this.currentContractData.currencyCode === "JPY" &&
        this.paymentType === "billing"
      );
    },
    isSpecialCreditPayment(): boolean {
      return (
        this.currentContractData.currencyCode === "EUR" &&
        this.currentContractData.termType === "year" &&
        this.changePlansData.settlementScheduledTerm === "month" &&
        this.paymentType === "card"
      );
    }
  }
});
